export const STAGE = isLocal() ? 'local' : import.meta.env.VITE_APP_STAGE

export const API_URLS = {
  local: 'http://localhost:8000',
  alpha: 'https://api-firmadok-alpha.ur-internal.com',
  development: 'https://api-firmadok.ur-internal.com',
  staging: 'https://api-staging.firmadok.no',
  production: 'https://api.firmadok.no',
}

export const API_URL = API_URLS[STAGE]

export const HERE_API_KEY = 'bTh0na4-sCovqZ9FZ0qC1ZfNbaXjUd0wOYOWFn8LQJs'

export const GOOGLE_API_KEY =
  process.env.NODE_ENV === 'production'
    ? 'AIzaSyCSVXw27xAwZX047OpceLY7Ml3E3KGKieg'
    : 'AIzaSyDTKbfMhsq-FvgXA1t9JUdYffOCGzK50oU'

export function isLocal() {
  return process.env.NODE_ENV !== 'production'
}

const FLEET_URLS = {
  local: 'http://localhost:3001',
  alpha: 'https://firmadok-fleet-alpha.ur-internal.com',
  development: 'https://fleet-dev.firmadok.no',
  staging: 'https://fleet-staging.firmadok.no',
  production: 'https://fleet.firmadok.no',
}

export const FLEET_URL = FLEET_URLS[STAGE]

const PLANNER_URLS = {
  local: 'http://localhost:3002',
  alpha: 'https://firmadok-planner-alpha.ur-internal.com',
  development: 'https://planner-dev.firmadok.no',
  staging: 'https://planner-dev.firmadok.no',
  production: 'https://planner.firmadok.no',
}

export const PLANNER_URL = PLANNER_URLS[STAGE]
